import React, { FC } from "react";
import styled from "styled-components";
import { Button3D } from "../../Components/Button3D";
import {
  HeaderTitle,
  MediumHeaderTitle,
  HeaderSubTitle
} from "../../Components/Text3D";
import FooterPublic3D from "../../Components/FooterPublic3D";
import { Row, Col, Typography, Image, Space, Carousel, Rate } from "antd";
import uploadIcon from "../../assets/images/upload.png";
import printerIcon from "../../assets/images/printer.png";
import modelIcon from "../../assets/images/model.png";
import payIcon from "../../assets/images/pay.png";
import pay2Icon from "../../assets/images/pay2.png";
import arrowIcon from "../../assets/images/arrow.svg";

import HeaderComponent from "../../Components/HeaderComponents";
import { useHistory } from "react-router-dom";
import MyCard from "../../Components/MyCard";
import { GET_ALL_DESIGNS } from "../../Apollo/graphql/Query";
import { useQuery } from "@apollo/client";

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: "100%";
  height: "100%";
  color: #ffffff;
`;

const HeroSection = styled.section`
  width: 100%;
  /* height: 100vh; */
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url("https://threedmake.s3.ap-southeast-2.amazonaws.com/assets/3dprint_hero.png");
  background-size: cover;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const HeroSectionContent = styled.section`
  text-align: center;
  color: #ffffff;
  padding-top: 10rem;
  padding-bottom: 3rem;
`;

const HeroSectionContentTitle = styled(Typography.Title)`
  &.ant-typography {
    color: #ffffff;
  }
`;
const HeroSectionContentSubTitle = styled(Typography.Title)`
  &.ant-typography {
    color: #ffffff;
    margin-top: 0;
    margin-bottom: 40px;
  }
`;

interface SectionProps {
  readonly dark?: boolean;
  readonly backgroundImage?: string;
}

const Section = styled.section<SectionProps>`
  width: 100%;
  background: ${(props) => (props.dark ? "#000" : "#FFF")};
  color: ${(props) => (props.dark ? "#FFF" : "#000")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background-size: cover;
  padding: 4rem 0;
  background-image: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : ""};
`;

const AboutSectionContent = styled.section`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;
// const AboutContent = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
// `;
const HIWText = styled(Typography.Paragraph)`
  font-size: 1rem;
`

const ContentContainer = styled.div`
  margin: 2.5rem 0;
`;

const MarketplaceSectionContent = styled(Col)`
  text-align: center;
`;

const HowitworksSectionContent = styled.section`
  text-align: center;
`;

const ArrowImage = styled.div`
  width: 50%;
  position: absolute;
  top: 19%;
  left: 85%;

  @media screen and (max-width: 768px) {
    display: none;
  }
  @media screen and (max-width: 860px) {
    top: 15%;
  }
  @media screen and (max-width: 960px) {
    top: 14%;
  }
  @media screen and (max-width: 1250px) {
    top: 18%;
  }
`;

const TestimonialSection = styled.div`
  padding: 0 2rem;
  margin: 2.5rem auto 0;
  max-width: 1034px;
  width: 100%;
  .slider-item {
    min-height: 260px;
  }
`;

const renderTestimonials = () => {
  return (
    <Carousel autoplay>
      <div className="slider-item">
        <div>
          <Rate defaultValue={5} disabled />
        </div>
        <MediumHeaderTitle style={{ fontSize: "1.5rem" }}>
          Prompt and responsive seller, quality of the print was the best I’ve
          seen. Would recommend.
        </MediumHeaderTitle>
        <HeaderSubTitle>~ TaterTots</HeaderSubTitle>
      </div>
      <div>
        <div>
          <Rate defaultValue={5} disabled />
        </div>
        <MediumHeaderTitle style={{ fontSize: "1.5rem" }}>
          Great communication, super quick, printed perfectly.
        </MediumHeaderTitle>
        <HeaderSubTitle>~ Mbix</HeaderSubTitle>
      </div>
      <div>
        <div>
          <Rate defaultValue={5} disabled />
        </div>
        <MediumHeaderTitle style={{ fontSize: "1.5rem" }}>
          Fast turn around, geat communication, high quality print. Very happy
          camper.
        </MediumHeaderTitle>
        <HeaderSubTitle>~ Wavefront</HeaderSubTitle>
      </div>
      <div>
        <div>
          <Rate defaultValue={5} disabled />
        </div>
        <MediumHeaderTitle style={{ fontSize: "1.5rem" }}>
          Great quality print and excellent communication.
        </MediumHeaderTitle>
        <HeaderSubTitle>~ Beezma</HeaderSubTitle>
      </div>
    </Carousel>
  );
}

const HomePageScreen: FC = () => {

  const { data } = useQuery(GET_ALL_DESIGNS, {
    variables: {
      pagination: {
        page: 1,
        limit: 3
      }
    }
  })

  const history = useHistory()
  return (
    <>
      <HomeContainer>
        <HeroSection>
          <HeaderComponent color="white" logo />
          <HeroSectionContent>
            <HeroSectionContentTitle>
              <HeaderTitle>Your 3D Printing Cheap</HeaderTitle>
            </HeroSectionContentTitle>
            <HeroSectionContentSubTitle>
              <MediumHeaderTitle fontSize>
                3D Printing from 5c per gram + $5 service fee + free
                pickup/$11.15 shipping <br />
                vs Jaycar 30c per gram + $14.95 service fee.
                <br />
                3D Printing satisfaction guarantee or your money back!
              </MediumHeaderTitle>
            </HeroSectionContentSubTitle>
            <Button3D
              type="primary"
              size="large"
              onClick={() => history.push("/design/upload")}
            >
              Print your Design
            </Button3D>
          </HeroSectionContent>
        </HeroSection>
        <Section>
          <HowitworksSectionContent>
            <Col
              md={{ span: 20, offset: 2 }}
              sm={{ span: 22, offset: 1 }}
              xs={{ span: 22, offset: 1 }}
            >
              <HeaderTitle dark>How It Works</HeaderTitle>
              <ContentContainer>
                <Row justify="space-between">
                  <Col md={4} xs={24}>
                    <Space size={"large"} direction="vertical">
                      <Image preview={false} src={uploadIcon} width={80} />
                      <HIWText style={{ fontSize: "1rem" }}>
                        Upload your design or select from marketplace
                      </HIWText>
                    </Space>
                    <ArrowImage>
                      <Image preview={false} src={arrowIcon} width="100%" />
                    </ArrowImage>
                  </Col>
                  <Col xs={24} md={4}>
                    <Space size={"large"} direction="vertical">
                      <Image preview={false} src={printerIcon} width={80} />
                      <HIWText>
                        Select the printer for the best print quality
                      </HIWText>
                    </Space>
                    <ArrowImage>
                      <Image preview={false} src={arrowIcon} width="100%" />
                    </ArrowImage>
                  </Col>
                  <Col xs={24} md={4}>
                    <Space size={"large"} direction="vertical">
                      <Image preview={false} src={modelIcon} width={80} />
                      <HIWText>
                        If you own the rights to the design, you can add it for
                        free or get paid to license it
                      </HIWText>
                    </Space>
                    <ArrowImage>
                      <Image preview={false} src={arrowIcon} width="100%" />
                    </ArrowImage>
                  </Col>
                  <Col xs={24} md={4}>
                    <Space size={"large"} direction="vertical">
                      <Image preview={false} src={payIcon} width={80} />
                      <HIWText>
                        Make payment and your print will be shipped to you
                      </HIWText>
                    </Space>
                    <ArrowImage>
                      <Image preview={false} src={arrowIcon} width="100%" />
                    </ArrowImage>
                  </Col>
                  <Col xs={24} md={4}>
                    <Space size={"large"} direction="vertical">
                      <Image preview={false} src={pay2Icon} width={80} />
                      <HIWText>
                        Get paid 85% of the sale price each time someone
                        downloads your file!
                      </HIWText>
                    </Space>
                  </Col>
                </Row>
              </ContentContainer>
            </Col>
          </HowitworksSectionContent>
        </Section>
        <Section dark style={{ background: "#000" }}>
          <HeaderTitle>
            What customers are saying about <br />
            <span style={{ color: "#1890ff" }}>3d Printit</span>
          </HeaderTitle>
          <TestimonialSection>{renderTestimonials()}</TestimonialSection>
        </Section>
        <Section
          dark
          backgroundImage="https://threedmake.s3.ap-southeast-2.amazonaws.com/assets/3dprint_footer_hero.png"
        >
          <MarketplaceSectionContent md={{ span: 22, offset: 1 }}>
            <HeaderTitle>Recent Prints by our Customers</HeaderTitle>
            <Col
              lg={{ span: 22, offset: 1 }}
              sm={{ span: 22, offset: 1 }}
              xs={{ span: 22, offset: 1 }}
              style={{ paddingTop: "2rem" }}
            >
              <Row wrap gutter={[32, 32]} justify="center">
                {data &&
                  data.designs.designs.map((s: any) => {
                    return (
                      <Col
                        key={s._id}
                        lg={{ span: 8 }}
                        sm={{ span: 24 }}
                        style={{ width: "100%" }}
                      >
                        <MyCard design={s} />
                      </Col>
                    );
                  })}
              </Row>
            </Col>
            <Button3D
              type="primary"
              size="large"
              style={{ marginTop: "2rem", fontSize: "2rem", height: "70px" }}
              onClick={() => history.push("/marketplace")}
            >
              Explore
            </Button3D>
          </MarketplaceSectionContent>
        </Section>
        <Section dark style={{ background: "#000" }}>
          <MediumHeaderTitle>
            Put Your Parts Into Production Today
          </MediumHeaderTitle>
          <AboutSectionContent>
            <Button3D
              type="primary"
              size="large"
              style={{ marginTop: "2rem" }}
              onClick={() => history.push("/design/upload")}
            >
              Get An Instant Quote
            </Button3D>
          </AboutSectionContent>
        </Section>
        <FooterPublic3D />
      </HomeContainer>
    </>
  );
};

export default HomePageScreen;
